import styled from "@emotion/styled";
import { Grid2 } from "@mui/material";

export const GridContainer = styled(Grid2)`
  position: relative;
  padding-top: ${p => p.theme.space[6]}px;
  margin-bottom: 50px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    padding-top: 48px;
    margin-bottom: 70px;
    flex-wrap: nowrap;
  }
`;
